module.exports = __webpack_public_path__ + "img/orange_118.09dec45e.png";